// extracted by mini-css-extract-plugin
export default {"container":"TypeText_container__P+Ei5"};